import { CommonApi } from './common'
import { HomeApi } from './home'
import { EnterpriseApi } from './enterprise'
import { UserApi } from './user'
import { ParkApi } from './park'
import { computerPepairApi } from './computer-pepair'

// API 接口类型声明
interface AppApi {
  common: CommonApi
  home: HomeApi
  enterprise: EnterpriseApi
  user: UserApi
  park: ParkApi
  computerpepair: computerPepairApi
}

// 统一的API实例
const $api: AppApi = {
  common: new CommonApi(),
  home: new HomeApi(),
  enterprise: new EnterpriseApi(),
  user: new UserApi(),
  park: new ParkApi(),
  computerpepair: new computerPepairApi(),
}

export default $api
